module.exports = __webpack_public_path__ + "static/media/bnr_ren5ad14a477a64d358422a115cceadbd2a.webp";